import { ConfirmationDialog } from "common/styleguide/ConfirmationDialog";
import { goalActions } from "data/resources/goals";
import { commonMessages, useFormatMessage } from "lib/localization";
import { errorMessage } from "lib/styleguide/base.scss";
import React, { useState } from "react";
import { defineMessages } from "react-intl";
import { connect } from "react-redux";

export const DELETE_CHALLENGE_MODAL = "DELETE_CHALLENGE_MODAL";

const messages = defineMessages({
  confirmText: {
    id: "DeleteChallengeModal.confirText",
    defaultMessage: "Yes, delete this Challenge",
  },
  confirmMsg: {
    id: "DeleteChallengeModal.confirmMsg",
    defaultMessage:
      "Deleting this Challenge cannot be undone. All details, Milestones, and participant information will be permanently removed.",
  },
});

export const _DeleteChallengeModal = ({ clubId, deleteGoal, onRequestClose }) => {
  const fm = useFormatMessage();
  const [deletePending, setDeletePending] = useState(false);
  const [deleteError, setDeleteError] = useState(false);

  const deleteChallenge = () => {
    if (deletePending) {
      return;
    }
    setDeletePending(true);
    deleteGoal()
      .then(() => {
        window.location = `/organizations/${clubId}/challenges`;
      })
      .catch(() => {
        setDeletePending(false);
        setDeleteError(true);
      });
  };

  return (
    <ConfirmationDialog
      maxWidth="600px"
      onRequestClose={onRequestClose}
      confirmText={fm(messages.confirmText)}
      onConfirm={deleteChallenge}
      confirmPending={deletePending}
      danger
    >
      <p>{fm(messages.confirmMsg)}</p>
      {deleteError && <div className={errorMessage}>{fm(commonMessages.errorMessageGeneric)}</div>}
    </ConfirmationDialog>
  );
};

export const DeleteChallengeModal = connect(null, (dispatch, ownProps) => ({
  deleteGoal: () => dispatch(goalActions.delete(ownProps.goalId)),
}))(_DeleteChallengeModal);
